import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  viewer: {
    company: {
      mapping: { employeesNeighborhoodsImportTemplateFile: string }
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, string>({
  handler: (data) => data.viewer.company.mapping.employeesNeighborhoodsImportTemplateFile,
  name: 'Neighborhood Import Template',
})

export default function template(): Promise<string> {
  return client.gql.query({ query }).then(mutateHandler)
}

const query = gql`
  query NeighborhoodTemplate {
    viewer {
      company {
        mapping {
          employeesNeighborhoodsImportTemplateFile
        }
      }
    }
  }
`
